// data/PoliciesSchemas.js
import { width } from "@mui/system";
import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";
export const policiesFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    width: "60%",
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Policy Code",
    value: "",
    isRequired: true,
    maxChar: 50,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_]+$/,
    patternMessage: "Invalid code. Use letters, numbers, - or _",
  },
  {
    id: "policyTypeId",
    label: "Select Policy Type",
    fieldType: "autocomplete",
    width: "60%",
    multiple: false,
    shownOnForm: true,
    isRequired: false,
    value: "",
    onSearch: (query, deps) => {
      deps.onSearchPolicyTypes(query);
    },
    options: (deps) => deps.policyTypes || [],
    valueKey: "id",
    textValue: "label",
  },
  {
    id: "cardId",
    label: "Assign Card",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {
      deps.onSearchCards(query);
    },
    options: (deps) => deps.cards || [],
    loading: (deps) => deps.cardsLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchCards) {
        deps.onSearchCards(searchValue);
      }
    },
  },
  {
    id: "employerName",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Employer Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Status",
    value: "active",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Pending Activation", label: "Pending Activation" },
      { value: "Active", label: "Active" },
      { value: "Expired", label: "Expired" },
      { value: "Suspended", label: "Suspended" },
    ],
  },
  {
    id: "effectiveDatetime",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Effective Date",
    value: "2026-12-31T00:00:00",
    isRequired: true,
    fieldType: "datetime",
    pattern: DATE_TIME_FORMAT_REG_EXP,
  },
  {
    id: "expiryDatetime",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Expiry Date",
    value: "2026-12-31T23:59:59",
    isRequired: true,
    fieldType: "datetime",
    pattern: DATE_TIME_FORMAT_REG_EXP,
  },
  {
    id: "insurees",
    label: "Covered Beneficiaries",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    columns: [
      {
        id: "name",
        label: "Insured Name",
        type: "textfield",
        isRequired: true,
        width: "30%",
      },
      {
        id: "relationship",
        label: "Relationship",
        type: "select",
        isRequired: true,
        width: "20%",
        options: () => [
          { value: "Principal", label: "Principal" },
          { value: "Spouse", label: "Spouse" },
          { value: "Child", label: "Child" },
          { value: "Others", label: "Others" },
        ],
      },
      {
        id: "gender",
        label: "Gender",
        type: "select",
        isRequired: true,
        width: "15%",
        options: () => [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
        ],
      },
      {
        id: "dateOfBirth",
        label: "DOB (YYYY-MM-DD)",
        type: "textfield", // Use textfield to match our import string format
        isRequired: true,
        width: "20%",
        placeholder: "YYYY-MM-DD",
      },
      {
        id: "mobilePhone",
        label: "Mobile",
        type: "textfield",
        isRequired: false,
        width: "15%",
      },
    ],
  },
  {
    id: "benefits",
    label: "Policy Benefits & Limits",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    isFixedList: true,
    columns: [
      {
        id: "policyItemId",
        label: "Benefit Item",
        type: "select",
        isRequired: true,
        // Add these three lines:
        optionsKey: "availablePolicyItems",
        valueKey: "id",
        textValue: "label",
      },
      {
        id: "limit",
        label: "Amount Limit",
        type: "number",
        isRequired: true,
        helperTextKey: "balance",
        helperTextVal: (balance) => `Bal: ${balance.toLocaleString("en-US")}`,
        sx: {
          mt: 0.5,
          fontSize: "0.75rem",
          color: "#953305",
          fontWeight: "bold",
        },
      },
      {
        id: "countLimit",
        label: "Count Limit",
        type: "number",
        isRequired: true,
        helperTextKey: "countBalance",
        helperTextVal: (countBalance) => `Visits: ${countBalance}`,
        sx: {
          mt: 0.4,
          fontSize: "0.65rem",
          color: "#033c6b",
          fontWeight: "bold",
        },
      },
    ],
  },
];

export const policiesRecord = {
  id: null,
  code: "",
  employerName: "",
  status: "active",
  effectiveDatetime: "",
  expiryDatetime: "",
  policyTypeId: null,
  cardId: null,
  benefits: [],
  insurees: [],
};
